
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { delGcashMultipleAccount, delGcashAccount } from '@/api/gcash/account'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'addAccount',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) list!: any

  get language () {
    return AppModule.language
  }

  private loading: boolean = false
  private back() {
    this.$emit('close')
  }

  private idList:any = []
  getDeteleId () {
    this.idList = []
    this.list.forEach(item => {
      this.idList.push(item.id)
    })
  }

  private create() {
    if (this.flag) {
      this.getDeteleId()
    }
    let str = this.idList.toString()
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          const params: any = {
            deleteid: str
          }
          if (action === 'confirm') {
            delGcashMultipleAccount(params).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.back()
            })
          }
        }
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          const params: any = {
            deleteid: str
          }
          // console.log(params, 'ppp')
          if (action === 'confirm') {
            delGcashMultipleAccount(params).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.back()
            })
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          const params: any = {
            deleteid: str
          }
          if (action === 'confirm') {
            delGcashMultipleAccount(params).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.back()
            })
          }
        }
      })
    }
  }

  private flag: boolean = true
  private handleSelectionChange (list) {
    // this.list = list
    if (list.length) {
      this.idList = []
      this.flag = false
      list.forEach(item => {
        this.idList.push(item.id)
      })
    } else {
      this.flag = true
    }
  }

  // 删除多个

  mounted() {}
}
